import React from "react";
import { Modal } from "@mui/material";
import statuteFromGroups from "../../../utils/statuteFromGroups";
import PopUpResponseButton from "../../Buttons/PopUpResponseButton/PopUpResponseButton";
import strings from "../../../locales/ro.json";
import "./MemberStatsModal.css";

const MemberStatsModal = ({ open, onClose, users }) => {
  const stats = React.useMemo(() => {
    let juniors = 0;
    let seniors = 0;
    let alumni = 0;

    users.forEach((user) => {
      const statute = statuteFromGroups(user);
      if (statute === "junior") juniors++;
      else if (statute === "senior") seniors++;
      else if (statute === "alumni") alumni++;
    });

    const quorum = Math.ceil((seniors + (juniors > 0 ? 1 : 0) + (alumni > 0 ? 1 : 0)) / 2);

    return {
      juniors,
      seniors,
      alumni,
      totalMembers: juniors + seniors,
      quorum,
    };
  }, [users]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="statsModalContainer">
        <div className="statsModalContent">
          <div className="statsModalHeader">{strings.usermanagement.statsModal.title}</div>
          <div className="statsModalDetails">
            <div className="statItem">
              <span className="statLabel">
                {strings.usermanagement.statsModal.activeMembers}:
              </span>
              <span className="statValue">{stats.totalMembers}</span>
            </div>
            <div className="statItem">
              <span className="statLabel">{strings.usermanagement.statsModal.quorum}:</span>
              <span className="statValue">{stats.quorum}</span>
            </div>
            <div className="statItem">
              <span className="statLabel">{strings.usermanagement.statsModal.seniors}:</span>
              <span className="statValue">{stats.seniors}</span>
            </div>
            <div className="statItem">
              <span className="statLabel">{strings.usermanagement.statsModal.juniors}:</span>
              <span className="statValue">{stats.juniors}</span>
            </div>
            <div className="statItem">
              <span className="statLabel">{strings.usermanagement.statsModal.alumni}:</span>
              <span className="statValue">{stats.alumni}</span>
            </div>
          </div>
          <div className="statsModalButton">
            <PopUpResponseButton
              type="cancel"
              text={strings.usermanagement.statsModal.closeButton}
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MemberStatsModal;
